<template>
  <StaffLayout section="Email Library">
    <h1 class="text-xl font-bold">AK Staff user profile:</h1>
    <p>
        You are logged in as {{ user?.loginEmail }}
    </p>
  </StaffLayout>
</template>

<script setup lang="ts">
// import { useBldgStore } from "../../store/bldgStore";
import { useUserStore } from "../../store/userStore";

// const bldgStore = useBldgStore();
 const userStore = useUserStore();

// const siteCode = bldgStore.bldgCode;
// var isPropertyLoading = computed(() => bldgStore.isLoading);
// var property = computed(() => bldgStore.property);

// let isUserLoading = computed(() => userStore.isUserLoading);

 let user = computed(() => userStore.user);
// let isLoggedIn = computed(() => userStore.isLoggedIn);
</script>
